// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rAEB","signatureBlock":"Footer_signatureBlock__3AO7E","signature":"Footer_signature__17J6d"};